
	<div id="page">
    <nav class="fh5co-nav" role="navigation" style="background-color: #5E6262;">
      <div class="container">
        <div class="row">
          <div class="col-xs-2 text-left">
            <div id="fh5co-logo">    <a [routerLink]="['/index']" class="navbar-brand mr-lg-5">
              <img src="assets/images/logo.png" style="height: 250%;"> </a></div>
          </div>
          <div class="col-xs-10 text-right menu-1 wow fadeInRight">
            <ul>
              <li class="active" style="color: #ffffff; font-family: '微軟正黑體';"><b>防疫時期, 企業部屬最佳選擇. 遠距視訊, 快速協作.</b></li>
              <li class="active"><a [routerLink]="['/message']"><img src="assets/images/free_1.png" style="width: 13%;"></a></li>
            </ul>
          </div>
        </div>

      </div>
    </nav>

	<header id="fh5co-header" class="fh5co-cover nav-img" role="banner" style="background-image:url(./assets/images/header.png); margin-top: 50px;">
		<div class="container">
			<div class="row">
				<div class="col-md-7 text-left title">
					<div class="display-t">
						<div class="display-tc wow fadeInUp">
              <h1 class="mb30" style="text-shadow: 10px 10px 10px #291503F0;font-weight: 550;margin-top:23%">企業獨立視訊通話APP</h1>
              <span class="header-button" style="margin-left:27%;"><a [routerLink]="['/message']"><img src="assets/images/free_1.png" style="width: 40%;"></a></span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</header>
	<div id="fh5co-project">
		<div class="container">
			<div class="row row-pb-md">
				<div class="col-md-8 col-md-offset-2 text-left fh5co-heading  wow fadeInUp">
					<h2>獨一無二 專屬為您</h2>
					<p>業界最佳的企業用視訊軟體<br />有了原碼 ，讓您不再考慮其他軟體</p>
				</div>
			</div>

			<div class="row">
				<div class="col-md-3 col-sm-6 fh5co-project wow fadeIn">
					<a href="#"><img src="assets/images/pic1.svg" alt="Free HTML5 Website Template by gettemplates.co" class="img-responsive">
						<div class="fh5co-copy">
							<p style="color:#ffffff; font-size: 17px;">App 簡易註冊</p>
						</div>
					</a>
				</div>
				<div class="col-md-3 col-sm-6 fh5co-project wow fadeIn">
					<a href="#"><img src="assets/images/pic2.svg" alt="Free HTML5 Website Template by gettemplates.co" class="img-responsive">
						<div class="fh5co-copy">
							<p style="color:#ffffff; font-size: 17px;">專屬的管理後台</p>
						</div>
					</a>
				</div>
				<div class="col-md-3 col-sm-6 fh5co-project wow fadeIn">
					<a href="#"><img src="assets/images/pic3.svg" alt="Free HTML5 Website Template by gettemplates.co" class="img-responsive">
						<div class="fh5co-copy">
							<p style="color:#ffffff; font-size: 17px;">視訊通話間同時文字訊息傳送</p>
						</div>
					</a>
				</div>
				<div class="col-md-3 col-sm-6 fh5co-project wow fadeIn">
					<a href="#"><img src="assets/images/pic4.jpg" alt="Free HTML5 Website Template by gettemplates.co" class="img-responsive">
						<div class="fh5co-copy">
							<h3 style="color:#ffffff; font-size: 17px;">視覺化報表<br /></h3><p>檢視會員通話次數及時間報表 (excel 下載)</p>
						</div>
					</a>
				</div>
			</div>
		</div>
	</div>

	<div id="fh5co-services" class="fh5co-bg-section border-bottom">
		<div class="container">
			<div class="row row-pb-md">
				<div class="col-md-8 col-md-offset-2 text-left wow fadeInUp">
					<div class="fh5co-heading">
						<h2>不受地域阻隔 與世界沒有距離</h2>
						<p>疫情當道，原碼提供團隊最佳的遠距上班工具，<br />讓您的工作、會議不受時間與距離的影響</p>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-3 col-sm-6" style="height: 300px;">
					<div class="feature-center wow fadeInUp">
						<span class="icon">
							<img src="assets/icon/1_vacancy.svg" width="20%">
						</span>
						<h3>專屬的管理後台</h3>
						<p>透過專屬後台輕鬆管理及更動App設定</p>
					</div>
				</div>
				<div class="col-md-3 col-sm-6 " style="height: 300px;">
					<div class="feature-center wow fadeInUp">
						<span class="icon">
							<img src="assets/icon/2_id-01.svg" width="20%">
						</span>
						<h3>App簡易註冊</h3>
						<p>減去繁瑣流程，輸入手機號碼及名稱即可成功註冊，提升效率</p>
					</div>
				</div>
				<div class="clearfix visible-sm-block"></div>
				<div class="col-md-3 col-sm-6 " style="height: 300px;">
					<div class="feature-center wow fadeInUp">
						<span class="icon">
							<img src="assets/icon/3_complaint-01.svg" width="20%">
						</span>
						<h3>後台審核註冊人員</h3>
						<p>提供管理人員進行審核成功及停權等權限控管的權利</p>
					</div>
				</div>

				<div class="clearfix visible-md-block"></div>

				<div class="col-md-3 col-sm-6 ">
					<div class="feature-center wow fadeInUp">
						<span class="icon">
							<img src="assets/icon/4_movie-film.svg" width="20%">
						</span>
						<h3>點對點(P2P)影音傳送</h3>
						<p>影音傳輸不通過伺服器，安全並大量節省伺服器流量費用</p>
					</div>
				</div>
				<div class="clearfix visible-sm-block"></div>
				<div class="col-md-3 col-sm-6 ">
					<div class="feature-center wow fadeInUp">
						<span class="icon">
							<img src="assets/icon/5_speech-bubble-01.svg" width="20%">
						</span>
						<h3>視訊通話時也能文字傳送</h3>
						<p>視訊會議時也能傳送文字訊息，提高效率且不干擾會議執行</p>
					</div>
				</div>
				<div class="col-md-3 col-sm-6 ">
					<div class="feature-center wow fadeInUp">
						<span class="icon">
							<img src="assets/icon/6_analytics-01.svg" width="20%">
						</span>
						<h3>視覺化報表</h3>
						<p>檢視會員通話次數及時間報表及Excel 下載，視覺化統計圖表，方便檢閱紀錄</p>
					</div>
				</div>
				<div class="col-md-3 col-sm-6 ">
					<div class="feature-center wow fadeInUp">
						<span class="icon">
							<img src="assets/icon/7_app.svg" width="20%">
						</span>
						<h3>企業獨立App</h3>
						<p>不與其他公司共用App，提升獨立專業性</p>
					</div>
				</div>
				<div class="col-md-3 col-sm-6 ">
					<div class="feature-center wow fadeInUp">
						<span class="icon">
							<img src="assets/icon/8_website.svg" width="20%">
						</span>
						<h3>專屬視覺界面</h3>
						<p>使用企業專屬Logo及配合企業色系設計調整，讓您的App獨一無二！</p>
					</div>
				</div>

				<div class="clearfix visible-md-block"></div>

			</div>
		</div>
	</div>

	<footer id="fh5co-footer" role="contentinfo" style="background-color: #2F2D2D;">
		<div class="container">
			<div class="row copyright">
				<div class="col-md-12 text-center">
					<p>
						<small class="block">地址 : 新北市中和區建八路2號4樓之7&nbsp&nbsp&nbsp&nbsp電話:02-8228-0407&nbsp&nbsp&nbspCopyright&copy;2020 原碼數位科技</small>
					</p>
				</div>
			</div>

		</div>
	</footer>
	</div>

	<div class="gototop js-top">
		<a href="#" class="js-gotop"><i class="icon-arrow-up"></i></a>
	</div>
